/*
 * Created on Wed Aug 09 2023
 *
 * Project: BKN_FRONT
 * Copyright (c) 2023 Nttdata
 */
import React from "react";

//COMPONENTS MUI
import { DataGrid } from '@mui/x-data-grid';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Snackbar from '@mui/material/Snackbar';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import MuiAlert from '@mui/material/Alert';
import {Button, Grid} from "@mui/material";

//COMPONENTS GOOGLE
import {GoogleMap, useLoadScript, Marker, InfoWindow, DirectionsRenderer} from "@react-google-maps/api";
import "@reach/combobox/styles.css";

import Nav from "../../components/RDAC/Nav.js";
import Instructions from "../../components/RDAC/Instructions.js";
import ReqDA from "../../components/RDAC/ReqDA.js";
import { GRID_DEFAULT_LOCALE_TEXT, PAGINATION } from "../../constants/localeTextGrid.js";
import renderCellExpansio from "../../components/RDAC/renderCellExpansio.js";

const libraries = ["places"]
const mapContainerStyle = {
  width : "100%",
  height : "100%"
}


export default function ConsultarDAs() {
  //Declarem google
  const google = window.google;

  //Agafem els parametres que rep la url
  const queryParams = new URLSearchParams(window.location.search);
  let coordX = queryParams.get('coordX');
  let coordY = queryParams.get('coordY');
  coordX = Number(coordX);
  coordY = Number(coordY);

  //Declaracio de hooks
  const [center, setCenter] = React.useState({lat : 41.8204600,lng : 1.8676800});
  const [markers, setMarkers] = React.useState([]);
  const [originMarker, setOriginMarker] = React.useState([]);
  const [selected, setSelected] = React.useState(null);
  const [selectedOrigin, setSelectedOrigin] = React.useState(null);
  const [mode, setMode] = React.useState('');
  const [directions, setDirections] = React.useState(null);
  const [instructions, setInstructions] = React.useState([]);
  const [jsonData, setjsonData] = React.useState(null);
  const [jsonLatLng, setjsonLatLng] = React.useState([]);
  const [open, setOpen] = React.useState(false);
  const [distancematrix, setDistancematrix] = React.useState([]);
  const [activarSliderInst, setActivarSliderInst] = React.useState(false);

  //Carrega del servei de google
  const {isLoaded, loadError} = useLoadScript({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_API_KEY,
    libraries,
    language: 'ca',
  });

  React.useEffect(() => {
    if (jsonLatLng.length === 15 && originMarker.length > 0) {
      const distanceMatrixService = new google.maps.DistanceMatrixService();
      distanceMatrixService.getDistanceMatrix(
      {
        destinations: jsonLatLng,
        origins: [{ lat: originMarker[0].lat, lng: originMarker[0].lng }],
        travelMode: mode.toString(),
      },
      (response, status) => {
        if (status === "OK") {
          setDistancematrix([...response.rows[0].elements]);
        } else {
          console.error(`Error fetching distance matrix: ${status}`);
        }
      });
    }
  }, [jsonLatLng, mode]);

  //Creació de la taula DataGrid
  const columns = [
    { field: 'DISTANCIA', headerName: 'Distància', width: 100, renderCell:(params) => {
        if(distancematrix.length === 15){
          const status_dist = distancematrix[params.row.ID - 1].status
          if(status_dist === 'OK'){
            const distance = [distancematrix[params.row.ID - 1].distance]
            return(
              <div>{distance.map((record,id) => (
                <div key={id}>{record.text}</div>
              ))}
              </div>
          )} else{
            return <div></div>
          }}else{
            return <div>Introdueix</div>
          }
    }, disableClickEventBubbling: true, headerAlign: 'center', align: 'center', },
    { type: 'number', field: 'TEMPS', headerName: 'Temps', width:150, renderCell:(params) => {
        if(distancematrix.length === 15){
          const status_time = distancematrix[params.row.ID - 1].status
          if(status_time === 'OK'){
            const duration = [distancematrix[params.row.ID - 1].duration]
            return(
              <div>{duration.map((record,id) => (
                <div key={id}>{record.text}</div>
              ))}
              </div>
          )} else{
            return <div></div>
        }}else{
          return <div> un transport</div>
        }
    }, disableClickEventBubbling: true, headerAlign: 'center', align: 'center', },
    { field: 'CALCULAR_RUTA', headerName: 'Instruccions', width: 150, renderCell: (params) => {
      return (
          <strong>
              <Button text="calc" onClick={() => { mode === '' ? AlertaTransportClick() :
                        calcroute({lat : params.row.LATITUD, lng : params.row.LONGITUD});
                        setActivarSliderInst(true);
                        }}>Calcular ruta</Button>
          </strong>
      )
    }, disableClickEventBubbling: true, headerAlign: 'center', align: 'center', },
    { field: 'HORARI', headerName: 'Horari', width: 150, renderCell: renderCellExpansio, disableClickEventBubbling: true, headerAlign: 'center', align: 'center', },
    { field: 'NOM_VIA', headerName: 'Nom via', width: 150, renderCell: renderCellExpansio, disableClickEventBubbling: true, headerAlign: 'center', align: 'center', },
    { type: 'number', field: 'NUMERO_VIA', headerName: 'Número via', width: 100 , disableClickEventBubbling: true, headerAlign: 'center', align: 'center', },
    { type: 'number', field: 'BL', headerName: 'Bloc', width: 75, disableClickEventBubbling: true, headerAlign: 'center', align: 'center',  },
    { type: 'number', field: 'ESCALA', headerName: 'Escala', width: 75,  disableClickEventBubbling: true, headerAlign: 'center', align: 'center',  },
    { type: 'number', field: 'PORTA', headerName: 'Porta', width: 75, disableClickEventBubbling: true, headerAlign: 'center', align: 'center', },
    { field: 'PIS', headerName: 'Pis', width: 75, disableClickEventBubbling: true, headerAlign: 'center', align: 'center', },
    { field: 'POBLACIO', headerName: 'Població', width: 150, renderCell: renderCellExpansio, disableClickEventBubbling: true, headerAlign: 'center', align: 'center',  },
    { field: 'NOM_DEL_CENTRE', headerName: 'Nom centre', width: 150, renderCell: renderCellExpansio, disableClickEventBubbling: true, headerAlign: 'center', align: 'center',  },
    { field: 'ESPAI_FISIC', headerName: 'Espai físic', width: 150 , renderCell: renderCellExpansio, disableClickEventBubbling: true, headerAlign: 'center', align: 'center', },
    { field: 'TELEFON_FIX', headerName: 'Telèfon fix', width: 150 , disableClickEventBubbling: true, headerAlign: 'center', align: 'center', },
    { field: 'TELEFON_MOVIL', headerName: 'Telèfon mòbil', width: 150, disableClickEventBubbling: true, headerAlign: 'center', align: 'center',  },    
  ];  
  
  const mapRef = React.useRef();

  const onMapLoad = React.useCallback((map) => {
    mapRef.current = map;
    if(Number(coordX) !== 0 && Number(coordY) !== 0){
        setMarkers(current => [...current,{
            lat: coordX,
            lng: coordY,
            time: new Date(),
          },]);
    }
    
  }, []);  

  const panTo = React.useCallback(({lat, lng, address}) => {
    mapRef.current.panTo({lat, lng});
    mapRef.current.setZoom(15);
    setOriginMarker((originMarker) => originMarker.filter((_,i) => i !== 0));
    distancematrix.length = 0;
    setCenter({lat : lat, lng : lng});
    setMarkers([])
    setSelected(null)
    setSelectedOrigin(null)
    setDirections(null)
    setInstructions([]);
    setjsonData(null)
    setjsonLatLng([])
    setOpen(false)
    setDistancematrix([])
    setActivarSliderInst(false)
    setOriginMarker(current => [...current,{
      lat: lat,
      lng: lng,
      val: address,
      time: new Date(),
    },]);
  }, []);  

  if (loadError){
    return "Error carregant el mapa";
  } 
  if (!isLoaded){
    return "Carregant Maps";
  }

  const directionsService = new google.maps.DirectionsService();

  const calcroute = (destination) => {
      directionsService.route(
        {
          origin: { lat : originMarker[0].lat, lng : originMarker[0].lng },
          destination: destination,
          travelMode: mode.toString(),
        },
        
        (result, status) => {
          if (status === google.maps.DirectionsStatus.OK) {
              setDirections(result)
              const array = []
              for(let i=0; i<result.routes[0].legs[0].steps.length; i++){
                array.push(result.routes[0].legs[0].steps[i].instructions);
              }
              setInstructions([...array])
          } else {
            console.error(`error fetching directions ${result}`);
          }
        }
      );
  }

  const handleChange = (event) => {
    setMode(event.target.value);
  };

  const AlertaTransportClick = () => {
    setOpen(true);
  };

  const AlertaTransportClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpen(false);
  };

  const action = (
    <React.Fragment>
      <IconButton
        size="small"
        aria-label="close"
        color="inherit"
        onClick={AlertaTransportClose}
      >
        <CloseIcon fontSize="small" color="secondary" />
      </IconButton>
    </React.Fragment>
  );
  
  const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
  });
  
  return (
    
    <div>
      <Grid className='Nav'>
        {/*Barra superior */}
        <Nav panTo={panTo}></Nav>
        <FormControl id="butt" >
          <InputLabel id="demo-simple-select-label" sx={{top: '-10px', transform: 'translate(14px, 10px) scale(0.75)'}}>Transport</InputLabel>
            <Select
              sx={{
                bgcolor: 'white',
                display: 'table-cell',
                height: '40px',
                verticalAlign: 'middle',
                fontFamily: 'Roboto, Arial, sans-serif',
                fontSize: '15px',
                minWidth: '130px',
                borderRadius: '10px',
              }}
              inputProps={{MenuProps: {disableScrollLock: true}}}
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={mode}
              label="Mode"
              onChange={handleChange}
            > 
              <MenuItem value={'DRIVING'}>En cotxe</MenuItem>
              <MenuItem value={'WALKING'}>A peu</MenuItem>
              <MenuItem value={'TRANSIT'}>Transport Públic</MenuItem>
            </Select>
          </FormControl>
      </Grid>
      <Instructions instructions={instructions} activarSliderInst={activarSliderInst} open={open}/>
      <Grid className = "mapa">
            <GoogleMap
              mapContainerStyle={mapContainerStyle} 
              zoom={7.5} 
              center={center}
              onLoad={onMapLoad}
            >
            {/*shouldRenderDistanceMatrix &&
              <DistanceMatrixService
                options={{
                  destinations: jsonLatLng,
                  origins: [{ lat : originMarker[0].lat, lng : originMarker[0].lng }],
                  travelMode: mode.toString(),
                }}
                callback = {(response) => {
                  setDistancematrix([...response.rows[0].elements])
                  setjsonLatLng([])
                }}
              />*/}
            {originMarker.map((marker,id) => (
                <Marker 
                    key={marker.time.toISOString()} 
                    position={{lat: marker.lat, lng: marker.lng}}
                    /*label={`${id}`}*/
                    onClick={() => {
                        setSelectedOrigin(marker);
                    }}
                />
            ))}
            {jsonLatLng.map((jsonmarkers,id) => (
                <Marker 
                    key={id}
                    position={{lat: jsonmarkers.lat, lng: jsonmarkers.lng}}
                    /*label={`${id}`}*/
                    onClick={() => {
                        setSelected(jsonmarkers);
                    }}
                    icon = {{
                      url: "/DA-red.png",
                      scaledSize: new google.maps.Size(30,30),

                    }}
                />
            ))}
            {markers.map((marker,id) => (
                <Marker 
                    key={marker.time.toISOString()} 
                    position={{lat: marker.lat, lng: marker.lng}}
                    /*label={`${id}`}*/
                    onClick={() => {
                        setSelected(marker);
                    }}
                />
            ))}
            
            <DirectionsRenderer directions={directions}/>
            
            {selectedOrigin ? (
                <InfoWindow 
                  position={{lat: selectedOrigin.lat, lng: selectedOrigin.lng}}
                  onCloseClick={() => {
                    setSelectedOrigin(null);
                  }}
                >
                  <div>
                    <p> <strong> ORIGEN </strong></p>
                    <p> <strong>Adreça: </strong>{selectedOrigin.val}</p>
                  </div>
                </InfoWindow>
              ) : null}
              {selected ? (
                <InfoWindow 
                  position={{lat: selected.lat, lng: selected.lng}}
                  onCloseClick={() => {
                    setSelected(null);
                  }}
                >
                  <div>
                    <p> <strong>Adreça: </strong>{selected.nomvia} , {selected.numvia} </p>
                    <p> <strong>Nom del centre: </strong>{ selected.nomcentre} </p>
                    <strong>
                      <Button text="calc" onClick={() => { mode === '' ? AlertaTransportClick() :
                        calcroute({lat : selected.lat, lng : selected.lng});
                        setActivarSliderInst(true);
                      }}>Calcular ruta</Button>
                    </strong>
                  </div>
                </InfoWindow>
              ) : null}
            </GoogleMap>
          </Grid>
          <Grid className="taulamapa">
            <div>
              <Snackbar 
                open={open} 
                autoHideDuration={6000}
                action={action}>
                <Alert onClose={AlertaTransportClose} severity="error" sx={{ width: '100%' }}>
                  Cal introduir un metode de transport !
                </Alert>
              </Snackbar>
              <h3>{originMarker.length === 0 ? "Afegeixi una direcció origen per veure els marcadors més propers" : 
                <ReqDA dataJSON={dataJSON => {
                  let lat = 0
                  let lng = 0
                  let nomvia = ''
                  let numvia = ''
                  let nomcentre = ''
                  dataJSON.map((json) => (
                    // eslint-disable-next-line
                    lat = Number(JSON.stringify(json.LATITUD)),
                    lng = Number(JSON.stringify(json.LONGITUD)),
                    nomvia = json.NOM_VIA,
                    numvia = json.NUMERO_VIA,                    
                    nomcentre = json.NOM_DEL_CENTRE,
                    setjsonLatLng(current => [...current,{
                      lat: lat,
                      lng: lng,
                      nomvia: nomvia,
                      numvia: numvia,
                      nomcentre: nomcentre,
                    },])));
                  //setjsonLatLng([...array])
                  setjsonData(dataJSON)
                  }} originlat={originMarker[0].lat} originlng={originMarker[0].lng} />}</h3>
              {jsonData ? (
                <div style={{height:'50vh', width:'100%'}}>
                  <DataGrid 
                    componentsProps={PAGINATION} 
                    localeText={GRID_DEFAULT_LOCALE_TEXT} 
                    rowWidth={'100%'} 
                    columns={columns}
                    rows={jsonData} 
                    getRowId={(row) => row.NUMERO_DE_SERIE}/></div>) : null}
          </div>
          </Grid>
      </div>
    )
  }